import { ExternalLink, ShieldCheck, Star, Store } from "lucide-react";

export const INDIAMART_URL = "https://www.indiamart.com/tahersteel-tubeco-coimbatore/";

/** Compact trust badge — used beside the quote CTA. */
export const IndiaMartBadge = () => (
  <a
    href={INDIAMART_URL}
    target="_blank"
    rel="noopener"
    className="inline-flex items-center gap-2 rounded-full border border-border bg-background px-4 py-2 font-body text-xs text-muted-foreground hover:text-accent hover:border-accent transition-colors"
  >
    <Store className="w-4 h-4 text-accent" aria-hidden="true" />
    Also verified on IndiaMART
    <ExternalLink className="w-3 h-3" aria-hidden="true" />
  </a>
);

/** Fuller panel with trust signals — used in the Contact section. */
export const IndiaMartPanel = () => (
  <div className="rounded-lg border border-border bg-secondary/40 p-6">
    <div className="flex items-center gap-3 mb-3">
      <div className="w-10 h-10 rounded bg-accent/10 flex items-center justify-center shrink-0">
        <Store className="w-5 h-5 text-accent" aria-hidden="true" />
      </div>
      <div>
        <p className="font-display text-sm font-semibold text-foreground">
          Buy from us on IndiaMART
        </p>
        <p className="font-body text-xs text-muted-foreground">
          Taher Steel Tube Co., Coimbatore — MS, GI, ERW &amp; seamless pipes
        </p>
      </div>
    </div>

    <ul className="space-y-2 mb-4">
      <li className="flex items-center gap-2 font-body text-sm text-muted-foreground">
        <ShieldCheck className="w-4 h-4 text-accent shrink-0" aria-hidden="true" />
        Verified IndiaMART supplier since 1990
      </li>
      <li className="flex items-center gap-2 font-body text-sm text-muted-foreground">
        <Star className="w-4 h-4 text-accent shrink-0" aria-hidden="true" />
        Rated by contractors, fabricators &amp; industrial buyers across India
      </li>
      <li className="flex items-center gap-2 font-body text-sm text-muted-foreground">
        <Store className="w-4 h-4 text-accent shrink-0" aria-hidden="true" />
        Full catalogue with live enquiry &amp; bulk pricing
      </li>
    </ul>

    <a
      href={INDIAMART_URL}
      target="_blank"
      rel="noopener"
      className="inline-flex items-center gap-2 rounded bg-accent px-5 py-2.5 font-display text-sm font-semibold text-accent-foreground hover:brightness-110 transition-all"
    >
      View our IndiaMART profile &amp; reviews
      <ExternalLink className="w-4 h-4" aria-hidden="true" />
    </a>
  </div>
);
